import { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import type { StreamSessionDoc } from '@racedash/shared'
import { db } from '../lib/firebase'

export interface CapturedSession extends StreamSessionDoc {
  id: string
}

/**
 * Every stream session captured for an event, on every channel.
 *
 * Shared by the channel map, which needs the names each channel used, and the
 * Captured channels panel, which shows them.
 */
export function useCapturedSessions(eventId: string | undefined) {
  const [sessions, setSessions] = useState<CapturedSession[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!eventId) {
      setSessions(null)
      return
    }
    return onSnapshot(
      query(collection(db, 'streamSessions'), where('eventId', '==', eventId), orderBy('lastSeenAt', 'desc')),
      (snap) => setSessions(snap.docs.map((d) => ({ id: d.id, ...(d.data() as StreamSessionDoc) }))),
      (e) => setError(e.message),
    )
  }, [eventId])

  return { sessions, error }
}
